/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Padlock icon
 *
 * @file PadLockIcon.jsx
 * @author Gladson Samuel S
 * @since 2.0.0
 */

import React from 'react';
import { SvgIcon } from '@mui/material';

function PadLockIcon(props) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M12 11.8496C13.1044 11.8496 13.9998 12.7452 14 13.8496C14 14.6887 13.4826 15.4053 12.75 15.7021V16.5C12.7497 16.914 12.4141 17.25 12 17.25C11.5859 17.25 11.2503 16.914 11.25 16.5V15.7021C10.5174 15.4053 10 14.6887 10 13.8496C10.0002 12.7452 10.8956 11.8496 12 11.8496Z" fill="#171717" />
      <path fillRule="evenodd" clipRule="evenodd" d="M12 3C14.7614 3 17 5.23858 17 8H18C19.6569 8 21 9.34315 21 11V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V11C3 9.34315 4.34315 8 6 8H7C7 5.23858 9.23858 3 12 3ZM6 10C5.44772 10 5 10.4477 5 11V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V11C19 10.4477 18.5523 10 18 10H6ZM12 5C10.3431 5 9 6.34315 9 8H15C15 6.34315 13.6569 5 12 5Z" fill="#171717" />
    </SvgIcon>
  );
}

export default PadLockIcon;
